import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/TiktokSpecialCampaignReport.graphql';
import { Query, QuerytiktokSpecialCampaignReportArgs } from '../../__generated__/globalTypes';

export const useTiktokSpecialCampaignReportQuery = (
  options?: QueryHookOptions<Query, QuerytiktokSpecialCampaignReportArgs>
) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QuerytiktokSpecialCampaignReportArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useTiktokSpecialCampaignReportLazyQuery = (
  options?: LazyQueryHookOptions<Query, QuerytiktokSpecialCampaignReportArgs>
): QueryResult<Query, QuerytiktokSpecialCampaignReportArgs> & {
  getTiktokSpecialCampaignReport: LazyQueryExecFunction<Query, QuerytiktokSpecialCampaignReportArgs>;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getTiktokSpecialCampaignReport, result] = useLazyQuery<Query, QuerytiktokSpecialCampaignReportArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getTiktokSpecialCampaignReport, ...result };
};

export const useTiktokSpecialCampaignReportPromiseQuery = () => {
  const client = useApolloClient();

  const getTiktokSpecialCampaignReport = useCallback(
    (options?: Omit<QueryOptions<QuerytiktokSpecialCampaignReportArgs, Query>, 'query'>) =>
      client.query<Query, QuerytiktokSpecialCampaignReportArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getTiktokSpecialCampaignReport };
};
// Suspense Query Hooks
export const useTiktokSpecialCampaignReportSuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QuerytiktokSpecialCampaignReportArgs>
) => {
  const result = useSuspenseQuery<Query, QuerytiktokSpecialCampaignReportArgs>(QUERY, {
    ...options
  });

  return result;
};
